import React, { useEffect } from "react";
import "gatsby-plugin-breadcrumb/gatsby-plugin-breadcrumb.css";
import { NavbarProvider } from "./src/context/navbarContext";
import { ReKycProvider } from "./src/context/rekycContext";

export const wrapRootElement = ({ element, props }) => {
  return (
    <>
      <NavbarProvider {...props}>
        <ReKycProvider {...props}>{element}</ReKycProvider>
      </NavbarProvider>
    </>
  );
};
